(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["support-details"] && !Shopify.designMode) return;
  try {
    
(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');

  const initCollapse = (scope) => {
    scope.querySelectorAll('[data-sc-collapse]').forEach((wrap) => {
      if (wrap.dataset.collapseReady === 'true') return;
      wrap.dataset.collapseReady = 'true';

      const grid = wrap.querySelector('[data-sc-collapse-grid]');
      const btn = wrap.querySelector('[data-sc-collapse-btn]');
      if (!grid || !btn) return;

      const items = Array.from(grid.children);
      const moreLabel = wrap.getAttribute('data-label-more') || 'View more';
      const lessLabel = wrap.getAttribute('data-label-less') || 'Show less';
      let expanded = false;

      const currentLimit = () => {
        const desktop = Number(wrap.getAttribute('data-limit-desktop') || '0');
        const mobile = Number(wrap.getAttribute('data-limit-mobile') || '0');
        return desktopQuery.matches ? desktop : mobile;
      };

      const apply = () => {
        const limit = currentLimit();
        const overflow = items.length > limit;
        btn.hidden = !overflow;

        items.forEach((item, index) => {
          item.hidden = overflow && !expanded && index >= limit;
        });

        if (!overflow) {
          expanded = false;
        }

        btn.textContent = expanded ? lessLabel : moreLabel;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      btn.addEventListener('click', () => {
        expanded = !expanded;
        apply();
      });

      const onViewportChange = () => apply();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', onViewportChange);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(onViewportChange);
      }

      apply();
    });
  };

  const roots = document.querySelectorAll('[data-section-type="support-details"]');

  roots.forEach((root) => {
    const paramKey = root.getAttribute('data-param-key') || 'type';
    const previewType = root.getAttribute('data-preview-type') || '';
    const params = new URLSearchParams(window.location.search);
    const type = (params.get(paramKey) || previewType || '').trim();
    const entries = root.querySelectorAll('[data-support-type]');
    const notFound = root.querySelector('[data-support-not-found]');
    let matched = null;

    entries.forEach((entry) => {
      const isMatch = type !== '' && entry.getAttribute('data-support-type') === type;
      entry.hidden = !isMatch;
      if (isMatch) matched = entry;
    });

    if (!matched && type === '' && entries.length === 1) {
      entries[0].hidden = false;
      matched = entries[0];
    }

    if (notFound) notFound.hidden = Boolean(matched);

    if (matched) {
      const tabs = matched.querySelectorAll('.sc-details__tab');
      const syncTabs = () => {
        const hash = window.location.hash;
        tabs.forEach((tab) => {
          tab.classList.toggle('is-active', hash !== '' && tab.getAttribute('href') === hash);
        });
        if (!hash && tabs.length) tabs[0].classList.add('is-active');
      };
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((item) => item.classList.remove('is-active'));
          tab.classList.add('is-active');
        });
      });
      syncTabs();
      window.addEventListener('hashchange', syncTabs);
      initCollapse(matched);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSupportNav(nav) {
    if (!nav || nav.dataset.scNavReady === 'true') return;
    nav.dataset.scNavReady = 'true';

    var links = nav.querySelectorAll('[data-sc-nav-link]');
    if (!links.length) return;

    var sections = [];

    links.forEach(function (link) {
      var id = link.getAttribute('data-sc-nav-link');
      var target = document.getElementById(id);
      if (target) {
        sections.push({ id: id, target: target });
      }

      link.addEventListener('click', function () {
        setActive(id);
      });
    });

    function setActive(activeId) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-sc-nav-link') === activeId);
      });
    }

    function updateActiveOnScroll() {
      var navHeight = nav.offsetHeight || 64;
      var offset = navHeight + 24;
      var currentId = sections.length ? sections[0].id : '';

      sections.forEach(function (section) {
        var top = section.target.getBoundingClientRect().top;
        if (top <= offset) {
          currentId = section.id;
        }
      });

      setActive(currentId);
    }

    window.addEventListener('scroll', updateActiveOnScroll, { passive: true });
    window.addEventListener('resize', updateActiveOnScroll);
    updateActiveOnScroll();
  }

  function boot() {
    document.querySelectorAll('[data-section-type="support-nav"]').forEach(initSupportNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var nav = event.target.querySelector('[data-section-type="support-nav"]');
    if (nav) initSupportNav(nav);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
